export default {
  sentiment: 'Sentimento',
  medias: 'Mídias',
  news: 'Portais',
  quotes: 'CITAÇÕES',
  valoration: 'EQ. PUBLICITÁRIA',
  centage: 'CENTIMETRAGEM',
  minute: 'MINUTAGEM',
};
